import React from "react";
import { Colors } from "../../../../../shared/theme";
import { textStyles } from "../../../../../shared/theme/fonts-ppv";

export default {
  formSection: {
    padding: "28px 30px 30px",
    display: "flex",
    flexDirection: "column",
    flex: 1,
    minHeight: 0,
    backgroundColor: "rgba(255, 255, 255, 0.1)",
  } as React.CSSProperties,
  sectionTitle: {
    ...textStyles.h3,
    color: Colors.grey800,
    marginBottom: "18px",
  } as React.CSSProperties,
  termsSection: {
    width: "100%",
    flex: 1,
    display: "flex",
    flexDirection: "column",
    minHeight: 0,
  } as React.CSSProperties,
  termsCard: {
    width: "100%",
    flex: 1,
    display: "flex",
    flexDirection: "column",
    gap: "18px",
    padding: "20px",
    borderRadius: "20px",
    backgroundColor: Colors.white,
    minHeight: 0,
    border: `1px solid ${Colors.grey100}`,
  } as React.CSSProperties,
  termsScroll: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    overflowY: "auto",
    paddingRight: "8px",
    minHeight: 0,
  } as React.CSSProperties,
  checkboxRow: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    cursor: "pointer",
    ...textStyles.body2,
    color: Colors.grey600,
  } as React.CSSProperties,
  checkboxLabel: {
    ...textStyles.subtitle2,
    color: Colors.grey800,
  } as React.CSSProperties,
  checkboxLabelDisabled: {
    ...textStyles.subtitle2,
    color: Colors.grey200,
  } as React.CSSProperties,
  buttonWrap: {
    marginTop: "auto",
    paddingTop: "8px",
  } as React.CSSProperties,
  submitButton: {
    marginTop: "20px",
    width: "100%",
    height: "56px",
    borderRadius: "999px",
    border: "none",
    ...textStyles.subtitle1,
    color: Colors.white,
    background: Colors.violet,
    boxShadow: "0 18px 30px rgba(122, 53, 240, 0.22)",
  } as React.CSSProperties,
  submitButtonDisabled: {
    boxShadow: "none",
  } as React.CSSProperties,
};
